<app-dialog [config]="dialogConfig" (onApply)="onApplyE.emit($event)"></app-dialog>
